export enum UserType {
  SELF = 'SELF',
  FRIENDS = 'FRIENDS',
  FRIENDSHIP_REQUEST_PENDING = 'FRIENDSHIP_REQUEST_PENDING',
  NOT_FRIENDS = 'NOT_FRIENDS',
  REQUESTED_FRIENDSHIP = 'REQUESTED_FRIENDSHIP',
}
